import { snakeToCamelConverter } from './snakeToCamel.js';
export const snakeToPascalConverter = (string) => snakeToCamelConverter(string.replace(/^\w/, (s) => s.toUpperCase()));
//# sourceMappingURL=snakeToPascal.js.map